import { useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { 
  moveInsuranceUpAction, 
  moveInsuranceDownAction 
} from '../../../../../../services/EncounterService/slice';

/**
 * Hook for handling insurance grid actions (move up/down)
 */
export function useInsuranceActions() {
  const dispatch = useAppDispatch();

  const handleMoveUp = useCallback(
    (insuranceId: string, event: React.MouseEvent) => {
      event.stopPropagation(); // Prevent row selection
      dispatch(moveInsuranceUpAction(insuranceId));
    },
    [dispatch]
  );

  const handleMoveDown = useCallback(
    (insuranceId: string, event: React.MouseEvent) => {
      event.stopPropagation(); // Prevent row selection
      dispatch(moveInsuranceDownAction(insuranceId));
    },
    [dispatch]
  );

  return { handleMoveUp, handleMoveDown };
}
